import { render, staticRenderFns } from "./document-upload-header.vue?vue&type=template&id=ead2164e&"
import script from "./document-upload-header.vue?vue&type=script&lang=ts&"
export * from "./document-upload-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports